import { getStorage } from '../../storage';
/**
 *
 * Looks in session storage for all campaign params that exist. Works in tandem with saveCampaign Params
 *
 * ```js
 * import { getCampaignParams } from '@minerva-analytics/pantheon';
 *
 * // Keys it looks for:
 * // [`campaign_source`, `campaign_name`, `campaign_medium`, `campaign_content`, `campaign_keyword`]
 *
 * const foundCampaignParams = getCampaignParams();
 * const campaignSource = foundCampaignParams.campaign_source;
 * ```
 *
 * @return {Object} The relevant campaign values found in session Storage
 *
 */

export var paramsToRetrieve = ["campaign_source", "campaign_name", "campaign_medium", "campaign_content", "campaign_keyword"];
export var getCampaignParams = function getCampaignParams() {
  var savedParams = {};
  paramsToRetrieve.forEach(function (param) {
    var retreived = getStorage({
      key: param,
      session: true
    });

    if (retreived) {
      savedParams[param] = retreived;
    }
  });
  return savedParams;
};
export default getCampaignParams;